<template>
  <div
    class="switch"
    :class="{ 'active': value }"
    @click.stop="handleClick"
  >
    <div>
      <div v-show="loading" class="loading">
        <i class="el-icon-loading" color="#fff" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'changevalue'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled || !this.loading) {
        this.$emit('change')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .switch {
    flex-shrink: 0;
    position: relative;
    overflow: hidden;
    width: 44px;
    height: 26px;
    border-radius: 30px;
    background: $color-gray-3;
    padding: 5px 6px;
    cursor: pointer;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 26px;
      border-radius: 30px;
      background: $color-yellow;
      opacity: 0;
      transition: opacity 0.3s;
    }
    > div {
      position: relative;
      z-index: 1;
      display: block;
      width: 16px;
      height: 16px;
      padding: 2px;
      border-radius: 16px;
      background: #fff;
      transition: transform 0.3s;
    }
    .loading {
      width: 12px;
      line-height: 12px;
      text-align: center;
      font-size: 12px;
    }
    &.active {
      background: none;
      &::before {
        opacity: 1;
      }
      > div {
        transform: translateX(100%);
      }
    }
  }
</style>
